import { Instagram, Facebook, Linkedin } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_rental-hub-india-11/artifacts/ww02po42_Tripzo%20new.png";

const SOCIALS = [
  {
    icon: Instagram,
    label: "Instagram",
    href: "https://www.instagram.com/tripzo.india/",
    testId: "social-instagram",
  },
  {
    icon: Facebook,
    label: "Facebook",
    href: "https://www.facebook.com/tripzoindia",
    testId: "social-facebook",
  },
  {
    icon: Linkedin,
    label: "LinkedIn",
    href: "https://in.linkedin.com/company/tripzoindia",
    testId: "social-linkedin",
  },
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1e2528] border-t border-[#3e4b55]/50 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span
                aria-label="Tripzo Rentals"
                className="block h-12 w-12 bg-no-repeat bg-center"
                style={{
                  backgroundImage: `url(${LOGO_URL})`,
                  backgroundSize: "200% auto",
                  backgroundPosition: "center 25%",
                }}
              />
              <span className="font-display text-3xl tracking-wider text-[#f7f7f7] leading-none">
                TRIPZO
              </span>
            </div>
            <p className="mt-5 text-sm md:text-base text-[#ccd3d6]/70 max-w-md font-light leading-relaxed">
              Two-wheeler rentals across India — from everyday scooters to
              flagship superbikes. Launching soon.
            </p>
          </div>

          <div className="flex items-center gap-3 md:gap-4">
            {SOCIALS.map(({ icon: Icon, label, href, testId }) => (
              <a
                key={label}
                data-testid={testId}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="inline-flex items-center justify-center w-11 h-11 rounded-sm border border-[#3e4b55] text-[#ccd3d6] hover:text-[#1e2528] hover:bg-[#e89b1f] hover:border-[#e89b1f] transition-all duration-300"
              >
                <Icon className="w-4 h-4" strokeWidth={1.8} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#3e4b55]/40 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs tracking-wide text-[#6f7c84]">
          <div data-testid="footer-copyright">
            © {year} Tripzo Rentals. All rights reserved.
          </div>
          <div className="flex items-center gap-5">
            <span className="link-underline cursor-default">Privacy</span>
            <span className="link-underline cursor-default">Terms</span>
            <span className="link-underline cursor-default">Press</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
